import { toast } from "helpers/Utils";
import { CHATBOT_ADD_COMMENT, CHATBOT_ADD_COMMENT_FAILED, CHATBOT_ADD_COMMENT_SUCCESS, CHATBOT_CLOSE_QUERY_FAILED, CHATBOT_CLOSE_QUERY_SUCCESS, CHATBOT_GET_COMMENT_HISTORY_FAILED, CHATBOT_GET_COMMENT_HISTORY_SUCCESS, GET_CHATBOT_DATA, GET_CHATBOT_DATA_FAILED, GET_CHATBOT_DATA_SUCCESS } from "./Action";

const initialState = {
  chatBotData: [],
  chatBotComments: [],
  message: "",
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHATBOT_DATA:
      return { ...state, loading: true, message: "" };
    case GET_CHATBOT_DATA_SUCCESS:
      return { ...state, chatBotData: action.data, message: action.message, loading: false };
    case GET_CHATBOT_DATA_FAILED:
      return { ...state, message: action.message };

    case CHATBOT_ADD_COMMENT:
      return { ...state, message: action.message };
    case CHATBOT_ADD_COMMENT_SUCCESS:
      toast(action.message, "", "success");
      return { ...state, chatBotComments: [...state.chatBotComments, action.data], message: action.message };
    case CHATBOT_ADD_COMMENT_FAILED:
      return { ...state, message: action.message };

    case CHATBOT_GET_COMMENT_HISTORY_SUCCESS:
      return { ...state, chatBotComments: action.data, message: action.message };
    case CHATBOT_GET_COMMENT_HISTORY_FAILED:
      return { ...state, message: action.message };

    case CHATBOT_CLOSE_QUERY_SUCCESS:
      toast(action.message, "", "success");
      return { ...state, message: action.message };
    case CHATBOT_CLOSE_QUERY_FAILED:
      toast(action.message, "", "error");
      return { ...state, message: action.message };

    default:
      return { ...state };
  }
};
